import { Button } from 'antd';
import { CloseCircle, TickCircle } from 'iconsax-react';
import { useState } from 'react';
import clsx from 'clsx';
import { StyledInput } from './styles';
import { useSelector } from 'react-redux';
import { selectLayout } from '@src/store/layout/layoutSlice';
import { Arrow } from '../Arrow';

interface PromoCodeInputProps {
  isLoading?: boolean;
  discountPercentage?: number;
  onRemove?: () => void;
  onApply: (code: string) => void;
}

export function PromoCodeInput({
  isLoading,
  discountPercentage,
  onRemove,
  onApply,
}: PromoCodeInputProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [promoCode, setPromoCode] = useState('');
  const layout = useSelector(selectLayout);

  const isApplied =
    typeof discountPercentage === 'number' && discountPercentage > 0;
  return (
    <div className='space-y-2'>
      <div
        className='flex items-center cursor-pointer my-4'
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? (
          <Arrow direction='down' className='text-black dark:text-white' />
        ) : (
          <Arrow direction='right' className='text-black dark:text-white' />
        )}
        <span className='ml-2 text-R-16 text-wl-on-surface opacity-70'>
          Do you have a promo code?
        </span>
      </div>

      {isOpen && (
        <div className='flex flex-col gap-2 p-4 bg-wl-background rounded-xl items-center'>
          <StyledInput
            size='large'
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            placeholder='Enter your promo code'
            type='text'
            suffix={
              isApplied ? (
                <div className='flex items-center gap-2.5'>
                  <div className='flex items-center w-fit bg-green-100 dark:bg-green-900/20 text-wl-on-background rounded-lg gap-2 px-2 py-1'>
                    <TickCircle variant='Bulk' width={16} height={16} />
                    <span className='text-M-10 tracking-[0.08em]'>Applied</span>
                  </div>

                  <CloseCircle
                    className='cursor-pointer'
                    width={24}
                    onClick={() => {
                      setPromoCode('');
                      onRemove?.();
                    }}
                    variant='Bulk'
                  />
                </div>
              ) : (
                <Button
                  size='small'
                  className={clsx(
                    'btn-secondary shadow-none h-8 px-4',
                    'disabled:!bg-wl-background opacity-10',
                    'disabled:!text-wl-on-background opacity-60'
                  )}
                  loading={isLoading}
                  type='primary'
                  onClick={() => onApply(promoCode)}
                  disabled={!promoCode.trim()}
                >
                  Apply
                </Button>
              )
            }
            variant='filled'
            className={clsx(
              'py-4 px-5 rounded-2xl w-full border-none',
              '!bg-wl-surface text-wl-on-background'
            )}
            theme={layout.theme}
          />
          {typeof discountPercentage === 'number' && discountPercentage > 0 && (
            <div className='text-green-600 text-R-12 w-full text-left'>
              You have {discountPercentage}% discount with this promo code
            </div>
          )}
        </div>
      )}
    </div>
  );
}
